<section class="section white-100" *ngIf="internationalPanelData">
  <div
    [ngClass]="
      insideContainer ? 'section-container-inside' : 'section-container'
    "
  >
    <div class="international-business-container">
      <div>
        <div class="international-business-heading mar-b-32">
          {{ internationalPanelData.title }}
        </div>
        <p class="product-blog-description mar-b-48 white">
          {{ internationalPanelData.content.content[0].content[0].value }}
        </p>
        <div class="landing-btn">
          <a
            href="{{ internationalPanelData?.buttons[0].fields.redirectLink | urlParams:queryParams}}"
            target="{{ internationalPanelData?.buttons[0].fields.actionType }}"
            class="btn btn-full"
          >
            {{ internationalPanelData?.buttons[0].fields.buttonTitle }}
          </a>
        </div>
      </div>
      <div class="international-business-blog">
        <ng-container
          *ngFor="let item of internationalPanelData?.component1; let i = index"
        >
          <div class="international-business" [ngClass]="getClass(i)">
            <div class="international-business-ico">
              <img
                loading="lazy"
                src="{{
                  item?.fields?.iconImage
                    ? item?.fields?.iconImage?.fields?.file?.url
                    : item?.fields?.imageicon
                      ? item?.fields?.imageicon?.fields?.file?.url
                      : ''
                }}"
                alt="{{
                  item?.fields?.iconImage
                    ? item?.fields?.iconImage?.fields?.file?.title
                    : item?.fields?.imageicon
                      ? item?.fields?.imageicon?.fields?.file?.title
                      : ''
                }}"
              />
            </div>
            <div>
              <h5 class="efficient-payment-heading">
                {{ item?.fields?.richTextTitle?.content[0]?.content[0]?.value }}
              </h5>
              <p class="efficient-payment-description mar-t-8">
                {{ item?.fields?.description.content[0].content[0].value }}
              </p>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
